import { render } from "./CatUpload.vue?vue&type=template&id=243fe3d7&scoped=true"
import script from "./CatUpload.vue?vue&type=script&lang=js"
export * from "./CatUpload.vue?vue&type=script&lang=js"

import "./CatUpload.vue?vue&type=style&index=0&id=243fe3d7&scoped=true&lang=css"

import exportComponent from "D:\\phpstudy_pro\\data.yuandiansiyu.com\\platform_frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-243fe3d7"]])

export default __exports__